import { ENV } from "../env";
import { umamiTrack } from "./umami";


// Vérifie si GA est actif et non opt-out
export const isGAEnabled = () => {
  if (ENV.IS_STAGING) return false; // Désactive GA en staging

  // Vérifie que gtag est chargé et que l'utilisateur n'a pas opt-out
  return typeof window !== 'undefined' &&
    typeof (window as any).gtag === 'function' &&
    !document.cookie.includes('analytics_optout=true');
};

export const pageview = (url: string) => {
  if (typeof window === 'undefined') return;

  event({
    action: 'page_view',
    page_title: document.title,
    page_location: window.location.href,
    page_path: url,
  });
};

export const event = ({ action, ...params }: { action: string;[key: string]: string | number | boolean }) => {
  // Umami is independent from GA: it must still receive the event when GA is
  // disabled (opt-out, blocker) so the funnel stays complete.
  // Page views are already auto-tracked by the Umami script.
  if (action !== 'page_view') {
    umamiTrack(action, params);
  }

  if (!isGAEnabled()) {
    console.log(`${new Date().toISOString()} [Next.js] [GA] DISABLED trigger event="${action}"`, params);
    return;
  }
  (window as any).gtag('event', action, params);
};


